import { render, staticRenderFns } from "./PurchaseOrderDetail.vue?vue&type=template&id=4e01ab60&scoped=true"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderDetail.vue?vue&type=style&index=0&id=4e01ab60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e01ab60",
  null
  
)

export default component.exports